module.exports = __webpack_public_path__ + "img/BD.939d737f.png";